
const ROOT = '/user-management'

const userManagementPaths = {
  root: ROOT,
  addUser: `${ROOT}/add-user`,
};

export default userManagementPaths;
